import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentReviewTab } from '@features/student-page/components/StudentReviewTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/$studentNo/reviews')({
    beforeLoad: requireRouteAudience(['staff', 'parent', 'student']),
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Reviews',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load student review information'>
            <Suspense fallback={<LoadingIndicator resource='review information'/>}>
                <StudentReviewTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
